import script from "./ArticleModalContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleModalContent.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleModalContent.vue?vue&type=style&index=0&id=dd4bde7c&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd4bde7c"]])

export default __exports__